/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';

import i18n from './locale/i18n'
import App from './components/app/App';
import * as serviceWorker from './components/app/serviceWorker';

import './css/Main.css'
import './css/Overwrite.css'

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();
